import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Language = 'auto-detect' | 'english' | 'arabic';

interface LanguageState {
  currentLanguage: Language;
}

// Helper function to get language from localStorage
const getStoredLanguage = (): Language => {
  try {
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem('language');
      if (stored && ['auto-detect', 'english', 'arabic'].includes(stored)) {
        return stored as Language;
      }
    }
  } catch (error) {
    console.warn('Failed to load language from localStorage:', error);
  }
  return 'auto-detect'; // Default fallback
};

// Helper function to save language to localStorage
const saveLanguageToStorage = (language: Language) => {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem('language', language);
    }
  } catch (error) {
    console.warn('Failed to save language to localStorage:', error);
  }
};

const initialState: LanguageState = {
  currentLanguage: getStoredLanguage(),
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      state.currentLanguage = action.payload;
      // Save to localStorage
      saveLanguageToStorage(state.currentLanguage);
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer; 